
    import { Component, Vue} from 'vue-property-decorator';
    import PageBase from "../PageBase.vue";

    import Tooltip from "@/components/survey/Tooltip.vue"

    import { namespace } from "vuex-class";   
    import "@/store/modules/application";
    const applicationState = namespace("Application");

    @Component({
        components:{
            PageBase,
            Tooltip
        }
    })

    export default class NextSteps extends Vue {
        
        @applicationState.Action
        public UpdateGotoPrevStepPage!: () => void

        @applicationState.Action
        public UpdateGotoNextStepPage!: () => void

        showLegalAssistance = false
        currentStep=0;
        currentPage=0;

        mounted(){
            this.currentStep = this.$store.state.Application.currentStep;
            this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
            //console.log(this.currentPage)
            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, false);
        }

        public onPrev() {
            this.UpdateGotoPrevStepPage()
        }

        public onNext() {
            this.UpdateGotoNextStepPage()
        }
    }
